<script setup lang="ts">
import { useConstants } from '~theme/composables/useConstants';

const { USER_STATS } = useConstants();
</script>

<template>
  <header class="header">
    <div class="header__lead lead">
      <p class="lead__wrap">
        累計ユーザー数<em class="lead__emphasis">{{ USER_STATS.countIn10K }}</em
        ><em class="lead__unit">万人</em>突破！
      </p>
    </div>
    <h2 class="header__heading heading">
      <slot>
        <p class="heading__main">
          質問に答えるだけで<br />あなたの家計が丸わかり！
        </p>
        <p class="heading__note">
          （所要時間：<em class="heading__emphasis">約3分</em>）
        </p>
      </slot>
    </h2>
  </header>
</template>

<style lang="scss" scoped>
.header {
  &__lead {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__heading {
    text-align: center;
  }
}

.lead {
  color: $color-text-and-object-accent-primary;
  font-size: 15px;
  font-weight: bold;

  @include mobile-only {
    font-size: 14px;
  }

  &:before,
  &:after {
    border-top: 1px solid;
    content: '';
    width: 3em;
  }
  &:before {
    margin-right: 1rem;
  }
  &:after {
    margin-left: 1rem;
  }

  &__wrap {
    display: inline-block;
  }

  &__emphasis {
    color: $color-text-and-object-accent-orange;
    font-size: 24px;
    margin-left: 3px;
    vertical-align: -1px;
  }

  &__unit {
    font-size: 18px;
    margin-right: 3px;
    color: $color-text-and-object-accent-orange;
  }
}

.heading {
  margin-top: 10px;
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 3px;
  line-height: 36px;

  & span {
    display: inline-block;
  }

  &__main {
    letter-spacing: normal;
  }

  &__note {
    margin-top: 10px;
    letter-spacing: normal;
    font-size: 20px;
  }

  &__emphasis {
    color: $color-text-and-object-accent-orange;
  }

  @include mobile-only {
    font-size: 24px;
    line-height: 31px;
  }
}
</style>
